import { render, staticRenderFns } from "./Keynotes_LAW.vue?vue&type=template&id=5c26c9ca"
import script from "./Keynotes_LAW.vue?vue&type=script&lang=js"
export * from "./Keynotes_LAW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports